module.exports = __webpack_public_path__ + "images/emoji/hankey.d59772ccce323cff1afe.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hankey.png
// module id = TIPO
// module chunks = 24